import React from "react";

/**
 * Whether content in a tree row's actions slot belongs in the tab order. Only the active row's actions do, so Tab goes
 * from the active item to its actions and then out of the tree instead of through every row's "..." button.
 */
export const TreeActionsTabbableContext = React.createContext(true);

/**
 * Puts focus back somewhere sensible after the focused element was removed, for example a row that "Remove ..."
 * took away. TreeView provides one that focuses its active row, SideDrawer one that falls back to the panel.
 */
export const FocusRestoreContext = React.createContext<(() => void) | undefined>(undefined);

/** True when nothing has focus any more, which is where focus ends up after the focused element is removed. */
export const isFocusLost = () => !document.activeElement || document.activeElement === document.body;
